import React from 'react';
import { type QnAStateType } from '../../reducers';
import { getValidationErrorMessage } from '../../reducers/selectors';
import { styled } from 'baseui';
type Props = {
  qnaState: QnAStateType;
  questionId: string;
};
const StyledError = styled('div', ({
  $theme
}) => ({
  color: $theme.colors.contentNegative,
  border: $theme.colors.borderNegative,
  fontSize: '0.8rem'
}));
export const TestId = 'questionValidationError';
export function QuestionValidation({
  qnaState,
  questionId
}: Props) {
  const validationError = getValidationErrorMessage(qnaState, questionId);
  return validationError ? <StyledError data-testid={TestId}>{validationError}</StyledError> : null;
}